/**
 * AppClientSearchMinisearch bond setup
 *
 * Wires @molecule/app-client-search-minisearch to @molecule/app-client-search
 * (the package and template catalog search).
 */

import { setProvider } from '@molecule/app-client-search'
import { provider } from '@molecule/app-client-search-minisearch'

export function setupAppClientSearchMinisearch(): void {
  setProvider(provider)
}
